import { getStore } from 'app/state/storeRegistry'
import { BaseDialogProps, DialogFactory, ExtractDialogProps, ShowDialogPayload } from './types'
import { pushDialog } from './state/dialogsSlice'

export function openDialog<PropsT extends BaseDialogProps>(def: ShowDialogPayload<PropsT>) {
  getStore().dispatch(pushDialog(def))
}

export function createDialogOpener<PropsT extends BaseDialogProps = BaseDialogProps>(
  factory: () => DialogFactory<PropsT>
) {
  return (props: ExtractDialogProps<PropsT>) => {
    openDialog({ factory, dialogProps: props })
  }
}
